import { FIELDS } from './constants';

const defaultFields = [
  /*{
    field: 'commands',
    title: ' ',
    cell: 'commands',
    headerCell: 'commandsHeader',
    sortable: false,
    hidden: false,
    locked: true,
    width: 40,
  },
  {
    field: 'selectcommands',
    title: ' ',
    cell: 'selectcommands',
    headerCell: 'selectCommandsHeader',
    sortable: true,
    hidden: false,
    locked: true,
    width: 30,
  },*/
  {
     key: 'source',
     field: FIELDS.SOURCE,
     title: 'Source',
     label: 'Source',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'sourceId',
     field: FIELDS.SOURCE_ID,
     title: 'Source Id',
     label: 'Source Id',
     cell: 'navigation',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'isPreferred',
     field: FIELDS.IS_PREFERRED,
     title: 'Preferred',
     label: 'Preferred',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'statusName',
     field: FIELDS.STATUS_NAME,
     title: 'Status',
     label: 'Status',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'partNumber',
     field: FIELDS.PART_NUMBER,
     title: 'Part Number',
     label: 'Part Number',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'mfgName',
     field: FIELDS.MFG_NAME,
     title: 'Mfr',
     label: 'Mfr',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'dateCode',
     field: FIELDS.DATE_CODE,
     title: 'Date Code',
     label: 'Date Code',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'required',
     field: FIELDS.REQUIRED,
     title: 'Qty Required',
     label: 'Qty Required',
     cell: 'formatSeparator',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'quantity',
     field: FIELDS.QUANTITY,
     title: 'Quantity Offered',
     label: 'Quantity Offered',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'cost',
     field: FIELDS.COST,
     title: 'Vend. Cost',
     label: 'Vend. Cost',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'price',
     field: FIELDS.PRICE,
     title: 'Cust. Target',
     label: 'Cust. Target',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'companyName',
     field: FIELDS.COMPANY_NAME,
     title: 'Company',
     label: 'Company',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'vendorName',
     field: FIELDS.VENDOR_NAME,
     title: 'Vendor',
     label: 'Vendor',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'vendorType',
     field: FIELDS.VENDOR_TYPE,
     title: 'Vendor Type',
     label: 'Vendor Type',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'rating',
     field: FIELDS.RATING,
     title: 'V Rating',
     label: 'V Rating',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'delivery',
     field: FIELDS.DELIVERY,
     title: 'Lead Time',
     label: 'Lead Time',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'warrantyName',
     field: FIELDS.WARRANTY_NAME,
     title: 'V Warranty',
     label: 'V Warranty',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'conditionName',
     field: FIELDS.CONDITION_NAME,
     title: 'Condition',
     label: 'Condition',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'leadFree',
     field: FIELDS.LEAD_FREE,
     title: 'RoHS',
     label: 'RoHS',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'vendorContactName',
     field: FIELDS.VENDOR_CONTACT_NAME,
     title: 'Vendor Contact',
     label: 'Vendor Contact',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'physPkg',
     field: FIELDS.PHYS_PKG,
     title: 'Phys Pkg',
     label: 'Phys Pkg',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'package',
     field: FIELDS.PACKAGE,
     title: 'Item Pkg',
     label: 'Item Pkg',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'piecePerPkg',
     field: FIELDS.PIECE_PER_PKG,
     title: 'SPQ',
     label: 'SPQ',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'countryOfOriginName',
     field: FIELDS.COUNTRY_OF_ORIGIN_NAME,
     title: 'COO',
     label: 'COO',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'warehouseName',
     field: FIELDS.WAREHOUSE_NAME,
     title: 'Warehouse',
     label: 'Warehouse',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'requirementDate',
     field: FIELDS.REQUIREMENT_DATE,
     title: 'Req Date',
     label: 'Req Date',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'customerPn',
     field: FIELDS.CUSTOMER_PN,
     title: 'Customer PN',
     label: 'Customer PN',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'altNumber',
     field: FIELDS.ALT_NUMBER,
     title: 'Alt Number',
     label: 'Alt Number',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'harmonizedCode',
     field: FIELDS.HARMONIZED_CODE,
     title: 'HTS Code',
     label: 'HTS Code',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'sku',
     field: FIELDS.SKU,
     title: 'SKU',
     label: 'SKU',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'bin',
     field: FIELDS.BIN,
     title: 'Bin',
     label: 'Bin',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'dateCreated',
     field: FIELDS.DATE_CREATED,
     title: 'Date Offered',
     label: 'Date Offered',
     cell: 'formatDate',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'dateModified',
     field: FIELDS.DATE_MODIFIED,
     title: 'Date Modified',
     label: 'Date Modified',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'scheduleB',
     field: FIELDS.SCHEDULE_B,
     title: 'Sched B',
     label: 'Sched B',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'lotCode',
     field: FIELDS.LOT_CODE,
     title: 'Lot Code',
     label: 'Lot Code',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'revision',
     field: FIELDS.REVISION,
     title: 'Revision',
     label: 'Revision',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'testingRequested',
     field: FIELDS.TESTING_REQUESTED,
     title: 'Requires Test (Yes/No)',
     label: 'Requires Test (Yes/No)',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'location',
     field: FIELDS.LOCATION,
     title: 'Location',
     label: 'Location',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'comment',
     field: FIELDS.COMMENT,
     title: 'Vend. Comments',
     label: 'Vend. Comments',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'needByDate',
     field: FIELDS.NEED_BY_DATE,
     title: 'Need Date',
     label: 'Need Date',
     sortable: true,
     hidden: false,
     width: 150,
  },
  {
    field: 'deletecommands',
    title: ' ',
    cell: 'deletecommands',
    headerCell: 'commandsHeader',
    sortable: true,
    hidden: false,
    locked: true,
    width: 30,
  },
]

export default defaultFields;
